
/**
 * Function used to check if KatalComponents have been registered with the browser yet.
 * @param {*} callBack Function to call once Katal components are registered with the browser
 */
function katalReady(callBack){
    if(window.KatalReady && window.KatalReady.katal){
        callBack();
    }
    else{
        document.addEventListener("katal-ready", function(){
            callBack();
        });
    }
}

module.exports = katalReady;
module.exports.default = katalReady;
